import React, { useState, useRef, useEffect } from 'react';
import SearchService from './index'; // Adjust path as needed
import searchIcon from '../../assets/img/icon/magnifier-icon.png'; // Adjust path as needed
// import searchIcon from '../../assets/img/landing/header-search-icon.png'
const SearchPopUp = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const searchRef = useRef(null);
  
  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target) && 
          !event.target.closest('.search-icon-container')) {
        setIsSearchOpen(false);
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      {/* Search icon that will trigger the popup */}
      <button className="search-icon-container" onClick={() => setIsSearchOpen(true)}>
        <img
          src={searchIcon}
          alt="Search Icon"
          height={30}
          width={30}
          className="search-icon" 
          
        />
        {/* <img
          src={searchIcon}
          alt="Search Icon"
          height={20}
          width={20}
          className="search-icon d-md-block d-none"
          
        /> */}
      </button>
      
      {/* Search Popup */}
      {isSearchOpen && (
        <div className="search-popup-overlay">
          <div className="search-popup" ref={searchRef}>
            <div className="search-popup-header">
              <h3>Search</h3>
              <button className="close-btn" onClick={() => setIsSearchOpen(false)}>×</button>
            </div>
            <div className="search-popup-content">
              <SearchService />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchPopUp;